const merkleProofURL = '/.netlify/functions/merkleProof?addr='
const onWhitelistURL = '/.netlify/functions/onWhitelist?addr='

export const generateProof = async (addr: string): Promise<string[]> => {
  try {
    const res = await fetch(merkleProofURL + addr)
    const data = await res.json()
    return data
  } catch (error) {
    console.error(error)
    return ['']
  }
}

export const isOnWhitelist = async (
  addr: string
): Promise<{ onWhitelist: boolean }> => {
  try {
    const res = await fetch(onWhitelistURL + addr)
    const data = await res.json()
    return data
  } catch (error) {
    console.error(error)
    return { onWhitelist: false }
  }
}
